// extracted by mini-css-extract-plugin
export default {"button":"button_button__xBNKc","primary":"button_primary__Wzs8G","important":"button_important__m5brv","short":"button_short__R8kpx","long":"button_long__tqylw"};